/**
 * Sanitize bad words from message text
 */
export function sanitizeBadWords(text, hide, placeholder) {
    if (hide === void 0) { hide = true; }
    if (placeholder === void 0) { placeholder = '***'; }
    if (hide) {
        return text.replace(/\[badword\].*?\[\/badword\]/g, placeholder);
    }
    else {
        return text.replace(/\[badword\](.*?)\[\/badword\]/g, '$1');
    }
}
